import 'inputmask';
import 'inputmask-multi';
import {ScrollSpy, Collapse, Popover} from 'bootstrap';
import validate from 'jquery-validation';
import SmoothScroll from 'smooth-scroll';
import Tick from '@pqina/flip';
import sourcebuster from 'sourcebuster';

$(document).ready(() => {
    const element = document.querySelector('#countdown');
    const now = new Date();

    if (startDate && startDate >= now) {
        const tick = Tick.DOM.create(element, {
            didInit: (tick) => {
                element.style.display = 'block';

                const locale = {
                    DAY_PLURAL: 'дней',
                    DAY_SINGULAR: 'день',
                    HOUR_PLURAL: 'часов',
                    HOUR_SINGULAR: 'час',
                    MINUTE_PLURAL: 'мин',
                    MINUTE_SINGULAR: 'мин',
                    SECOND_PLURAL: 'сек',
                    SECOND_SINGULAR: 'сек',
                };

                for (let key in locale) {
                    if (!locale.hasOwnProperty(key)) {
                        continue;
                    }
                    tick.setConstant(key, locale[key]);
                }

                const counter = Tick.count.down(startDate.toISOString());
                counter.onupdate = (value) => {
                    tick.value = value;
                };

                counter.onended = () => {
                    element.style.display = 'none';
                };
            }
        });

    }

    // Navigation Bar

    const collapse = new Collapse(document.querySelector('.navbar-collapse'), {toggle: false});
    $('.navbar-brand, .nav-link').click(() => {
        collapse.hide()
    });

    const navbarCollapse = () => {
        const $nav = $('#navigation');
        if ($nav.offset().top > 100) {
            $nav.addClass('navbar-shrink');
        } else {
            $nav.removeClass('navbar-shrink');
        }
    }

    navbarCollapse();
    $(window).scroll(navbarCollapse);

    new ScrollSpy(document.body, {target: '#navigation', offset: 56});

    // Smooth Scroll

    const scroll = new SmoothScroll('a[href*="#"]', {speed: 250, offset: 56});
    document.addEventListener('scrollStart', (event) => {
        if (event.detail && event.detail.anchor && event.detail.anchor.id) {
            const anchor = event.detail.anchor;
            const toggle = event.detail.toggle;
            const id = anchor.id;
            if (id.includes('become') && $(anchor).is(':hidden')) {
                event.preventDefault();
                $(anchor).slideDown('fast', () => {
                    scroll.animateScroll(anchor, toggle);
                });
            }
        }
    }, false);

    // Promo buttons next block

    $('.btn-next').each((index, el) => {
        const $el = $(el);
        const $span = $el.children('span');
        const $currentSection = $el.parents('section');
        if ($currentSection && $span) {
            const $nextSection = $currentSection.nextAll('section');
            if ($nextSection) {
                const anchor = `#${$nextSection.attr('id')}`
                const btn = $nextSection.data('btn');
                if (anchor) $el.attr('href', anchor);
                if (btn) $span.html(btn);
                if (anchor && btn) $el.show().css('display', 'inline-block');
            }
        }
    });

    // Validation 

    // Register Form

    function normalize(value) {
        return $.trim(value);
    }

    $.validator.setDefaults({
        onfocusout: function (e) {
            this.element(e);
        },
        onkeyup: false,
        highlight: (element) => {
            $(element).closest('.form-control').removeClass('is-valid').addClass('is-invalid');
        },
        unhighlight: (element) => {
            $(element).closest('.form-control').removeClass('is-invalid').addClass('is-valid');
        },
        errorElement: 'div',
        errorClass: 'invalid-feedback',
        errorPlacement: (error, element) => {
            if (element.parent('.input-group-prepend').length) {
                $(element).siblings(".invalid-feedback").append(error);
            } else {
                if (element.attr('id') === 'agree') {
                    const parent = element.parent();
                    parent.append(error);
                } else if (element.attr('name') === 'FormatID') {
                    error.appendTo('.format-block');
                } else {
                    error.insertAfter(element);
                }
            }
        }
    });

    $.validator.addMethod('cyrillic', function (value, element, regexp) {
        return this.optional(element) || regexp.test(value);
    });

    const $attendeeForm = $('#attendee-form');
    const $conference = $('#conference');

    $attendeeForm.validate({
        rules: {
            FirstName: {
                required: true,
                maxlength: 100,
                cyrillic: /^[а-яё\-\s]+$/iu
            },
            LastName: {
                required: true,
                maxlength: 100,
                cyrillic: /^[а-яё\-\s]+$/iu
            },
            MidName: {
                minlength: 2,
                maxlength: 100,
                cyrillic: /^[а-яё\-\s]+$/iu
            },
            Title: {
                required: true,
                minlength: 2,
                maxlength: 1000
            },
            Company: {
                required: true,
                minlength: 2,
                maxlength: 1000
            },
            Alias: {
                minlength: 2,
                maxlength: 1000
            },
            Phone: {
                required: true,
                maxlength: 55,
                remote: {
                    type: 'POST',
                    url: '/api/register/phone',
                    data: {
                        conference: () => $conference.val(),
                        number: () => $('#phone').val(),
                        type: 'phone'
                    }
                }
            },
            Extension: {
                maxlength: 10
            },
            Mobile: {
                required: true,
                maxlength: 55,
                remote: {
                    type: 'POST',
                    url: '/api/register/phone',
                    data: {
                        conference: () => $conference.val(),
                        number: () => $('#mobile').val(),
                        type: 'mobile'
                    }
                }
            },
            Mail: {
                required: true,
                maxlength: 1000,
                email: true
            },
            Personal: {
                maxlength: 1000,
                email: true
            },
            FormatID: {
                required: true
            },
            Agree: {
                required: true
            }
        },
        messages: {
            SearchLastName: {
                required: 'Фамилию необходимо заполнить',
                maxlength: 'Фамилия не должна превышать 100 знаков',
                cyrillic: 'Пожалуйста заполняйте фамилию кириллицей, по-русски'
            },
            SearchMobile: {
                required: 'Заполните мобильный телефон',
                maxlength: 'Мобильный телефон не должен превышать 55 знаков'
            },
            FirstName: {
                required: 'Имя необходимо заполнить',
                maxlength: 'Имя не должно превышать 100 знаков',
                cyrillic: 'Пожалуйста заполняйте имя кириллицей, по-русски'
            },
            LastName: {
                required: 'Фамилию необходимо заполнить',
                maxlength: 'Фамилия не должна превышать 100 знаков',
                cyrillic: 'Пожалуйста заполняйте фамилию кириллицей, по-русски'
            },
            MidName: {
                minlength: 'Слишком короткое отчество (мин 2 знака)',
                maxlength: 'Отчество не должно превышать 100 знаков',
                cyrillic: 'Пожалуйста заполняйте отчество кириллицей, по-русски'
            },
            Title: {
                required: 'Должность необходимо заполнить',
                minlength: 'Слишком короткая должность (мин 2 знака)',
                maxlength: 'Должность не должна превышать 1000 знаков'
            },
            Company: {
                required: 'Заполните официальное наименование',
                minlength: 'Слишком короткое название компании (мин 2 знака)',
                maxlength: 'Официальное название компании не должно превышать 1000 знаков'
            },
            Alias: {
                minlength: 'Слишком короткое название компании (мин 2 знака)',
                maxlength: 'Общеизвестное название компании не должно превышать 1000 знаков'
            },
            Phone: {
                required: 'Заполните рабочий телефон',
                maxlength: 'Рабочий телефон не должен превышать 55 знаков'
            },
            Extension: {
                maxlength: 'Внутренний телефон не должен превышать 10 знаков'
            },
            Mobile: {
                required: 'Заполните мобильный телефон',
                maxlength: 'Мобильный телефон не должен превышать 55 знаков'
            },
            Mail: {
                required: 'Рабочую эл. почту необходимо заполнить',
                maxlength: 'Рабочая эл. почта не должна превышать 1000 знаков',
                email: 'Неверный формат эл. почты'
            },
            Personal: {
                maxlength: 'Личная эл. почта не должна превышать 1000 знаков',
                email: 'Неверный формат эл. почты'
            },
            FormatID: {
                required: 'Пожалуйста выберите формат вашего участия'
            },
            Agree: {
                required: 'К сожалению, согласно закону о персональных данных, мы должны получить от Вас согласие'
            }
        }
    });


// Input Mask

    const world = $.masksSort($.masksLoad('/js/phone-codes.json'), ['#'], /[0-9]|#/, 'mask');
    const mask = {
        inputmask: {
            definitions: {'#': {validator: '[0-9]', cardinality: 1}},
            showMaskOnHover: false,
            autoUnmask: true,
            clearMaskOnLostFocus: true
        },
        match: /[0-9]/,
        replace: '#',
        listKey: 'mask'
    };
    $('input[type="tel"]').inputmasks($.extend(true, {}, mask, {list: world}));

// Source Buster

    sourcebuster.init({
        callback: (sb) => {
            $('input[name="SourceType"]').val(sb.current.typ);
            $('input[name="SourceName"]').val(sb.current.src);
            $('input[name="SourceMedium"]').val(sb.current.mdm);
            $('input[name="SourceCampaign"]').val(sb.current.cmp);
            $('input[name="SourceContent"]').val(sb.current.cnt);
            $('input[name="SourceTerm"]').val(sb.current.trm);
        }
    });

// Popovers

    [...document.querySelectorAll('[data-bs-toggle="popover"]')].forEach(el => new Popover(el));
    
});